module.exports = __webpack_public_path__ + "images/avatar2.svg";